import React, { useState, useEffect, useRef } from 'react'

const LazyLoadComponent = (props) => {
    const [visible, setVisible] = useState(props.visible);
    const placeholderRef = useRef(null);
    useEffect(() => {

        if (!visible && placeholderRef.current) {
            const observer = new IntersectionObserver(([{ intersectionRatio }]) => {
                if (intersectionRatio > 0) {
                    setVisible(true);
                }
            });
            observer.observe(placeholderRef.current);
            return () => observer.disconnect();
        }
    }, [visible, placeholderRef]);
    return (visible
        ?
        props.children
        :
        <div className='loading' ref={placeholderRef} />
    );
};

export default LazyLoadComponent
